import React from 'react'
/*  */
import { useContext } from "react";
import CartContext from "../context/CartContext";
import {useParams,useNavigate} from 'react-router-dom';
/*  */



const OrderSummary = () => {
  /*  */
  const params = useParams();
  const navigate = useNavigate();
  const { cart, setCart } = useContext(CartContext);

  // const removeItem = (idx) => {
  //   let tempCart = [...cart];
  //   tempCart.splice(idx, 1);
  //   setCart([...tempCart]);
  // };

  let total = cart.reduce((acc, curVal) => {
    return acc + curVal.qty * curVal.price;
  }, 0);

  
  /*  */
  return (
    <div>
      <h2>OrderSummary</h2>
  <form>
  <label for="fname">First name:</label> &#160;
  <input type="text" id="fname" name="fname"/><br/>
  <label for="lname">Last name:</label> &#160;
  <input type="text" id="lname" name="lname"/><br/>
  <label for="addres">Addres:</label> &#160;
  <input type="text" id="addres" name="addres"/><br/>
  <label for="addres">City:</label> &#160;
  <input type="text" id="city" name="city"/><br/>
  <label for="addres">Email:</label> &#160;
  <input type="email" id="email" name="email"/><br/>
  </form>
    <div className="container">
      {cart.length > 0 ? (
        <table className="table table-striped">
          <thead>
            <tr>
              <th scope="col">Id</th>
              <th scope="col">Image</th>
              <th scope="col">Name</th>
              <th scope="col">Unit Price</th>
              <th scope="col">Qty</th>
              <th scope="col">Price</th>
              <th scope="col">Remove</th>
            </tr>
          </thead>
          <tbody id="cartTable">
            {cart.map((item, idx) => {
              return (
                <tr key={item.id}>
                  <th scope="row">{item.id}</th>
                  <td>
                    <img src={`${item.image}`} alt="" height="30px" />
                  </td>
                  <td>{item.title}</td>
                  <td>${item.price}</td>
                  <td>{item.qty}</td>
                  <td>${item.price * item.qty}</td>
                  {/* <td>
                    <button
                      className="btn btn-danger"
                      onClick={() => removeItem(idx)}
                    >
                      X
                    </button>
                  </td> */}
                </tr>
              );
            })}
            <tr>
              <td>total</td>
              <td>${total}</td>
              {/* <td>
                <button className="btn btn-danger" onClick={() => setCart([])}>
                  Clear Cart
                </button>
              </td> */}
              <td>
                <button onClick={() => navigate("/")}>Check out</button>
              </td>
            </tr>
          </tbody>
        </table>
      ) : (
        <h4 className="text-center">There are no products in this cart.</h4>
      )}
    </div>
    </div>
  )
}

export default OrderSummary
